import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ErrorEventNotificationViewPage from "./pages/ErrorEventNotificationViewPage.vue";
import ErrorEventInformationViewPage from "./pages/ErrorEventInformationViewPage.vue";
import ErrorEventViewPage from "./pages/ErrorEventViewPage.vue";

export const ErrorEventRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "error-event"
) => [
  {
    name: "ErrorEventNotificationViewPage",
    path: `${prefix}/notification`,
    component: ErrorEventNotificationViewPage,
    meta: { title: "Error Event Notification" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.ERROR_EVENT_NOTIFICATION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ErrorEventInformationViewPage",
    path: `${prefix}/event/:id`,
    component: ErrorEventInformationViewPage,
    meta: { title: "Error Event event Information" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.ERROR_EVENT_NOTIFICATION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ErrorEventViewPage",
    path: `${prefix}/event/`,
    component: ErrorEventViewPage,
    meta: { title: "Error Event" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.ERROR_EVENT_NOTIFICATION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ErrorEventFromNotiIdViewPage",
    path: `${prefix}/event/notification/:id?`,
    component: ErrorEventViewPage,
    meta: { title: "Error Event" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.ERROR_EVENT_NOTIFICATION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
